(function () {
  const PREORDER_DEPOSIT_VARIANT_IDS = window.preorderQuantityLimitVariants || [];

  async function enforcePreorderQuantity() {
    try {
      const response = await fetch(
        `${Shopify.routes.root}cart.js`,
        {
          headers: {
            "Accept": "application/json"
          }
        }
      );

      if (!response.ok) {
        return;
      }

      const cart = await response.json();

      const invalidItems = cart.items.filter((item) =>
        PREORDER_DEPOSIT_VARIANT_IDS.includes(Number(item.variant_id)) &&
        item.quantity > 1
      );

      if (invalidItems.length === 0) {
        return;
      }

      for (const item of invalidItems) {
        await fetch(
          `${Shopify.routes.root}cart/change.js`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              "Accept": "application/json"
            },
            body: JSON.stringify({
              id: item.key,
              quantity: 1
            })
          }
        );
      }

      // Refresh the cart so the customer sees quantity 1
      window.location.reload();

    } catch (error) {
      console.error(
        "Preorder quantity limit check failed:",
        error
      );
    }
  }

  // Run when the page loads
  document.addEventListener(
    "DOMContentLoaded",
    enforcePreorderQuantity
  );
})();